import uuidv1 from 'uuid/v1';
import {LOG_IN, LOG_IN_SUCCESS, SIGN_UP, SIGN_UP_SUCCESS, SIGN_UP_ERROR, LOG_OUT} from '../ReduxActions/AuthAction'

const initialState = {
  user: {},

  signInError: false,
  signUpError: false,

  sessionId: uuidv1()

  // @TODO Check that on Log Out, the sessionId stays the same
}

const Auth  = (state = initialState, action) => {
  switch(action.type) {
    case LOG_IN:
    return {
      ...state,
      isAuthenticating: true,
      signInError: false
    }

    case LOG_IN_SUCCESS:
    return {
      ...state,
      isAuthenticating: false,
      user: action.user
    }

    case SIGN_UP: 
    return {
      ...state,
      isAuthenticating: true,
      signUpError: false
    }

    case SIGN_UP_SUCCESS:
    return {
      ...state,
      isAuthenticating: false,
      signUpError: false,
      user: action.user
    }
    
    case SIGN_UP_ERROR:
    return {
      ...state,
      isAuthenticating: false,
      signUpError: true
    }

    case LOG_OUT:
    return {
      ...initialState,
      sessionId: state.sessionId
    }

    default:
      return state;
  }
}

export default Auth;